module.exports = __webpack_public_path__ + "fonts/MoskauGrotesk-Light.1e7d993f.woff";